import React, { useEffect, useRef } from "react";
import { HamburgerIcon } from "@chakra-ui/icons";
import {
    Box, Flex, List, ListItem, Button, useDisclosure, Drawer, DrawerOverlay,
    DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody
} from "@chakra-ui/react";

type ResponsiveHeaderProps = {
    name?: React.ReactNode;
    navItems?: React.ReactNode[];
    sidebar: React.ReactNode;
    title?: string; // Drawer のヘッダー名（例: BLOCKs）
};

const ResponsiveHeader: React.FC<ResponsiveHeaderProps> = ({
                                                               name = null,
                                                               navItems,
                                                               sidebar,
                                                               title = "BLOCKs"
                                                           }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const hasOpened = useRef(false);

    useEffect(() => {
        if (!hasOpened.current) {
            hasOpened.current = true;
            onOpen();
        }
    }, []);
    useEffect(() => {
        console.log("name prop:", name);
    }, [name]);

    return (
        <>
            <Flex align="center" justify="space-between" h="100%" px={0}>
                <Flex align="center" gap={4}>
                    <Box>{name}</Box>
                    <Button onClick={onOpen} variant="ghost" p={2} minW="40px" minH="40px">
                        <HamburgerIcon color="white" boxSize={4} />
                    </Button>

                </Flex>

                <List m="0" display="flex" alignItems="center" gap={2}>
                    {navItems?.map((item, index) => (
                        <ListItem key={index}>{item}</ListItem>
                    ))}
                </List>
            </Flex>

            <Drawer
                isOpen={isOpen}
                placement="left"
                onClose={onClose}
                trapFocus={false}
                blockScrollOnMount={false}
            >
                <DrawerOverlay />
                <DrawerContent bg="black" color="white" maxW="250px">
                    <DrawerCloseButton color="white" marginTop={3} />
                    <DrawerHeader fontSize="24px" fontWeight="bold" marginBottom={1} height={59}>{title}</DrawerHeader>
                    <DrawerBody px={0}>
                        {sidebar}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>
    );
};

export default ResponsiveHeader;